import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-vehicle-unavailable',
  templateUrl: './modal-vehicle-unavailable.component.html',
  styleUrls: ['./modal-vehicle-unavailable.component.scss']
})
export class ModalVehicleUnavailableComponent {
  constructor (public activeModal: NgbActiveModal) {}
}
